var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.5V16.5H22V18.5H0ZM3 15.5C2.45 15.5 1.97917 15.3042 1.5875 14.9125C1.19583 14.5208 1 14.05 1 13.5V2.5C1 1.95 1.19583 1.47917 1.5875 1.0875C1.97917 0.695833 2.45 0.5 3 0.5H19C19.55 0.5 20.0208 0.695833 20.4125 1.0875C20.8042 1.47917 21 1.95 21 2.5V13.5C21 14.05 20.8042 14.5208 20.4125 14.9125C20.0208 15.3042 19.55 15.5 19 15.5H3ZM3 13.5H19V2.5H3V13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsActive);
export default __webpack_public_path__ + "static/media/operationsActive.29a44cfab6326a7b41ce301f0208d0a7.svg";
export { ForwardRef as ReactComponent };